var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    stroke: "#1B1D21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2223 6.10352C17.4598 6.32227 17.6848 6.54727 17.8973 6.77852L20.4566 7.14414C20.8737 7.86836 21.1951 8.64357 21.4129 9.45039L19.8566 11.5223C19.8566 11.5223 19.8848 12.1598 19.8566 12.4785L21.4129 14.5504C21.1961 15.3576 20.8746 16.1329 20.4566 16.8566L17.8973 17.2223C17.8973 17.2223 17.4566 17.6816 17.2223 17.8973L16.8566 20.4566C16.1324 20.8737 15.3572 21.1951 14.5504 21.4129L12.4785 19.8566C12.1604 19.8848 11.8404 19.8848 11.5223 19.8566L9.45039 21.4129C8.64322 21.1961 7.86789 20.8746 7.14414 20.4566L6.77852 17.8973C6.54727 17.6785 6.32227 17.4535 6.10352 17.2223L3.54414 16.8566C3.12712 16.1324 2.8057 15.3572 2.58789 14.5504L4.14414 12.4785C4.14414 12.4785 4.11602 11.841 4.14414 11.5223L2.58789 9.45039C2.80469 8.64322 3.12617 7.86789 3.54414 7.14414L6.10352 6.77852C6.32227 6.54727 6.54727 6.32227 6.77852 6.10352L7.14414 3.54414C7.86836 3.12712 8.64357 2.8057 9.45039 2.58789L11.5223 4.14414C11.8404 4.11601 12.1604 4.11601 12.4785 4.14414L14.5504 2.58789C15.3576 2.80469 16.1329 3.12617 16.8566 3.54414L17.2223 6.10352Z",
    stroke: "#1B1D21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e1cd8f5c6f101a9cc3a9e0390fa36127.svg";
export { ForwardRef as ReactComponent };